import api from './api';

export interface Student {
  id: number;
  first_name: string;
  last_name?: string;
  email?: string;
  birth_date?: string;
  student_id?: string;
  class_group: number;
  class_group_name?: string;
  phone_number?: string;
  parent_gender?: 'M' | 'F';
  parent_phone?: string;
  pronote_username?: string;
  pronote_password?: string;
  color?: string;
  password?: string;
  profile_picture?: string;
  hourly_rate?: number;
  maths_specialite?: boolean;
  order: number;
  created_at: string;
  updated_at: string;
}

class StudentService {
  async getAll(params?: any): Promise<Student[]> {
    const response = await api.get('/students/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getStudent(id: number): Promise<Student> {
    const response = await api.get(`/students/${id}/`);
    return response.data;
  }

  async create(data: Partial<Student>): Promise<Student> {
    const response = await api.post('/students/', data);
    return response.data;
  }

  async update(id: number, data: Partial<Student>): Promise<Student> {
    const response = await api.patch(`/students/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/students/${id}/`);
  }

  async getPlaintextPasswords(): Promise<Record<string, string>> {
    const response = await api.get('/plaintext-passwords/');
    return response.data;
  }

  async uploadProfilePicture(id: number, file: File): Promise<Student> {
    const formData = new FormData();
    formData.append('profile_picture', file);
    const response = await api.patch(`/students/${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
}

const studentService = new StudentService();
export default studentService;
